/**
 * Cinematic routes — full-screen presentation and lab surfaces that
 * intentionally run outside the authenticated app shell.
 *
 * These routes do not require a signed-in user. Global providers should
 * skip their mount-time /auth/me and /toto/assets fetches when the
 * initial pathname matches, so the network tab stays quiet during a
 * live keynote or observation session.
 *
 * Why a path prefix instead of a route boundary: the app's global
 * providers wrap the entire router, so a per-route guard would require
 * an invasive refactor. This single-line predicate is contained and
 * carries no risk to the authenticated app shell.
 */
export function isCinematicPath(pathname) {
  if (!pathname) return false;
  return pathname === "/present" || pathname.startsWith("/lab/");
}
